import { render, staticRenderFns } from "./PortfolioTwo.vue?vue&type=template&id=202a4198&"
import script from "./PortfolioTwo.vue?vue&type=script&lang=js&"
export * from "./PortfolioTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('202a4198')) {
      api.createRecord('202a4198', component.options)
    } else {
      api.reload('202a4198', component.options)
    }
    module.hot.accept("./PortfolioTwo.vue?vue&type=template&id=202a4198&", function () {
      api.rerender('202a4198', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/portfolio/PortfolioTwo.vue"
export default component.exports